//! Common
export const SET_IS_LOADING = 'SET_IS_LOADING';
export const SET_IS_SIDEBAR_OPEN = 'SET_IS_SIDEBAR_OPEN';

//* Description Modal
export const OPEN_DESCRIPTION_MODAL = 'OPEN_DESCRIPTION_MODAL';
export const CLOSE_DESCRIPTION_MODAL = 'CLOSE_DESCRIPTION_MODAL';

//! Auth
export const SUPERADMIN_ADMIN_LOGIN = 'SUPERADMIN_ADMIN_LOGIN';
export const PARTNER_LOGIN = 'PARTNER_LOGIN';

export const CHANGE_PASSWORD = 'CHANGE_PASSWORD';
export const LOGOUT = 'LOGOUT';

export const SUPERADMIN_ADMIN_FORGET_PASSWORD = 'SUPERADMIN_ADMIN_FORGET_PASSWORD';
export const PARTNER_FORGET_PASSWORD = 'PARTNER_FORGET_PASSWORD';
export const RESET_PASSWORD = 'RESET_PASSWORD';

//* Superadmin-Admin-Partner Details
export const GET_SUPERADMIN_ADMIN_PARTNER_DETAILS = 'GET_SUPERADMIN_ADMIN_PARTNER_DETAILS';
export const SET_SUPERADMIN_ADMIN_PARTNER_DETAILS = 'SET_SUPERADMIN_ADMIN_PARTNER_DETAILS';

//! Dashboard 
export const GET_DASHBOARD = "GET_DASHBOARD";
export const SET_DASHBOARD = "SET_DASHBOARD";
export const GET_RECENT_ACTIVITY = "GET_RECENT_ACTIVITY";
export const SET_RECENT_ACTIVITY = "SET_RECENT_ACTIVITY";

// Todo: Superadmin Module
//! Admin
export const GET_ADMINS = 'GET_ADMINS';
export const SET_ADMINS = 'SET_ADMINS';
export const GET_ADMIN_BY_ID = 'GET_ADMIN_BY_ID';
export const SET_ADMIN_BY_ID = 'SET_ADMIN_BY_ID';
export const CREATE_ADMIN = 'CREATE_ADMIN';
export const UPDATE_ADMIN = 'UPDATE_ADMIN';
export const DELETE_ADMIN = 'DELETE_ADMIN';

//* Partner
export const GET_PARTNER_BY_ADMINID = "GET_PARTNER_BY_ADMINID";
export const SET_PARTNER_BY_ADMINID = "SET_PARTNER_BY_ADMINID";

//* Partner Bank Detail
export const GET_PARTNER_BANK_DETAILS = "GET_PARTNER_BANK_DETAILS";
export const SET_PARTNER_BANK_DETAILS = "SET_PARTNER_BANK_DETAILS";
export const GET_ACTIVE_PARTNER_BANK_DETAIL = "GET_ACTIVE_PARTNER_BANK_DETAIL";
export const SET_ACTIVE_PARTNER_BANK_DETAIL = "SET_ACTIVE_PARTNER_BANK_DETAIL";
export const CREATE_PARTNER_BANK_DETAIL = "CREATE_PARTNER_BANK_DETAIL";
export const UPDATE_PARTNER_BANK_DETAIL = "UPDATE_PARTNER_BANK_DETAIL";
export const DELETE_PARTNER_BANK_DETAIL = "DELETE_PARTNER_BANK_DETAIL";
export const CHANGE_PARTNER_BANK_DETAIL_STATUS = "CHANGE_PARTNER_BANK_DETAIL_STATUS";

//! Admin Report Wallet
export const GET_ADMIN_REPORT_WALLETS = "GET_ADMIN_REPORT_WALLETS";
export const SET_ADMIN_REPORT_WALLETS = "SET_ADMIN_REPORT_WALLETS";
export const CREATE_ADMIN_REPORT_WALLET = "CREATE_ADMIN_REPORT_WALLET";
export const UPDATE_ADMIN_REPORT_WALLET = "UPDATE_ADMIN_REPORT_WALLET";
export const DELETE_ADMIN_REPORT_WALLET = "DELETE_ADMIN_REPORT_WALLET";

//! Registration Number
export const GET_REGISTRATION_NUMBERS = "GET_REGISTRATION_NUMBERS";
export const SET_REGISTRATION_NUMBERS = "SET_REGISTRATION_NUMBERS";
export const CREATE_REGISTRATION_NUMBER = "CREATE_REGISTRATION_NUMBER";
export const UPDATE_REGISTRATION_NUMBER = "UPDATE_REGISTRATION_NUMBER";
export const DELETE_REGISTRATION_NUMBER = "DELETE_REGISTRATION_NUMBER";

//! Video: Tutorials & Business
export const GET_VIDEOS = "GET_VIDEOS";
export const SET_TUTORIAL_VIDEOS = "SET_TUTORIAL_VIDEOS";
export const SET_BUSINESS_VIDEOS = "SET_BUSINESS_VIDEOS";
export const CREATE_VIDEO = "CREATE_VIDEO";
export const UPDATE_VIDEO = "UPDATE_VIDEO";
export const DELETE_VIDEO = "DELETE_VIDEO";
export const CHANGE_VIDEO_STATUS = "CHANGE_VIDEO_STATUS";

//! Blog
export const GET_BLOGS = "GET_BLOGS";
export const SET_BLOGS = "SET_BLOGS";
export const GET_BLOG_BY_ID = "GET_BLOG_BY_ID";
export const SET_BLOG_BY_ID = "SET_BLOG_BY_ID";
export const CREATE_BLOG = "CREATE_BLOG";
export const UPDATE_BLOG = "UPDATE_BLOG";
export const DELETE_BLOG = "DELETE_BLOG";

//! Coupon
export const GET_COUPONS = "GET_COUPONS";
export const SET_COUPONS = "SET_COUPONS";
export const CREATE_COUPON = "CREATE_COUPON";
export const UPDATE_COUPON = "UPDATE_COUPON";
export const DELETE_COUPON = "DELETE_COUPON";

//! Coupon
export const GET_REPORT_MODULES = "GET_REPORT_MODULES";
export const SET_REPORT_MODULES = "SET_REPORT_MODULES";
export const GET_REPORTS = "GET_REPORTS";
export const SET_REPORTS = "SET_REPORTS";
export const CREATE_REPORT = "CREATE_REPORT";
export const UPDATE_REPORT = "UPDATE_REPORT";
export const DELETE_REPORT = "DELETE_REPORT";
export const CHANGE_REPORT_STATUS = "CHANGE_REPORT_STATUS";

export const GET_GENERATED_REPORTS = "GET_GENERATED_REPORTS";
export const SET_GENERATED_REPORTS = "SET_GENERATED_REPORTS";
export const GET_CUSTOMERS_ALL = "GET_CUSTOMERS_ALL";
export const SET_CUSTOMERS_ALL = "SET_CUSTOMERS_ALL";

// Todo: Admin Module
//! Partner
export const GET_PARTNERS = "GET_PARTNERS";
export const SET_PARTNERS = "SET_PARTNERS";
export const SET_AFFILIATES = "SET_AFFILIATES";
export const GET_PARTNER_BY_ID = "GET_PARTNER_BY_ID";
export const SET_PARTNER_BY_ID = "SET_PARTNER_BY_ID";
export const CREATE_PARTNER = "CREATE_PARTNER";
export const UPDATE_PARTNER = "UPDATE_PARTNER";
export const DELETE_PARTNER = "DELETE_PARTNER";
export const CHANGE_PARTNER_STATUS = "CHANGE_PARTNER_STATUS";

///* Customer
export const GET_CUSTOMER_BY_PARTNERID = "GET_CUSTOMER_BY_PARTNERID";
export const SET_CUSTOMER_BY_PARTNERID = "SET_CUSTOMER_BY_PARTNERID";

//! Partner Report Wallet
export const GET_PARTNER_REPORT_WALLETS = 'GET_PARTNER_REPORT_WALLETS';
export const SET_PARTNER_REPORT_WALLETS = 'SET_PARTNER_REPORT_WALLETS';
export const CREATE_PARTNER_REPORT_WALLET = 'CREATE_PARTNER_REPORT_WALLET';
export const UPDATE_PARTNER_REPORT_WALLET = 'UPDATE_PARTNER_REPORT_WALLET';
export const DELETE_PARTNER_REPORT_WALLET = 'DELETE_PARTNER_REPORT_WALLET';

// Todo: Partner Module
//! Customer
export const GET_CUSTOMERS = "GET_CUSTOMERS";
export const SET_CUSTOMERS = "SET_CUSTOMERS";
export const GET_CUSTOMER_BY_ID = "GET_CUSTOMER_BY_ID";
export const SET_CUSTOMER_BY_ID = "SET_CUSTOMER_BY_ID";

//! Customer Report Wallet
export const GET_CUSTOMER_REPORT_WALLETS = 'GET_CUSTOMER_REPORT_WALLETS';
export const SET_CUSTOMER_REPORT_WALLETS = 'SET_CUSTOMER_REPORT_WALLETS';
export const CREATE_CUSTOMER_REPORT_WALLET = 'CREATE_CUSTOMER_REPORT_WALLET';
export const UPDATE_CUSTOMER_REPORT_WALLET = 'UPDATE_CUSTOMER_REPORT_WALLET';
export const DELETE_CUSTOMER_REPORT_WALLET = 'DELETE_CUSTOMER_REPORT_WALLET';

// Todo: Setting
//! Static Page
export const CREATE_UPDATE_STATIC_PAGE = 'CREATE_UPDATE_STATIC_PAGE';
export const GET_TERMS_OF_USE = 'GET_TERMS_OF_USE';
export const SET_TERMS_OF_USE = 'SET_TERMS_OF_USE';
export const GET_PRIVACY_POLICY = 'GET_PRIVACY_POLICY';
export const SET_PRIVACY_POLICY = 'SET_PRIVACY_POLICY';
export const GET_SHIPPING_POLICY = 'GET_SHIPPING_POLICY';
export const SET_SHIPPING_POLICY = 'SET_SHIPPING_POLICY';
export const GET_REFUND_POLICY = 'GET_REFUND_POLICY';
export const SET_REFUND_POLICY = 'SET_REFUND_POLICY';
export const GET_ABOUT_US = 'GET_ABOUT_US';
export const SET_ABOUT_US = 'SET_ABOUT_US';

//! Site Settings
export const GET_SITE_SETTINGS = 'GET_SITE_SETTINGS';
export const SET_SITE_SETTINGS = 'SET_SITE_SETTINGS';
export const CREATE_UPDATE_SITE_SETTINGS = 'CREATE_UPDATE_SITE_SETTINGS';

//! Awards
export const GET_AWARDS = 'GET_AWARDS';
export const SET_AWARDS = 'SET_AWARDS';
export const CREATE_AWARD = 'CREATE_AWARD';
export const UPDATE_AWARD = 'UPDATE_AWARD';
export const DELETE_AWARD = 'DELETE_AWARD';
export const CHANGE_AWARD_STATUS = 'CHANGE_AWARD_STATUS';

//! Media Coverage
export const GET_MEDIA_COVERAGE = 'GET_MEDIA_COVERAGE';
export const SET_MEDIA_COVERAGE = 'SET_MEDIA_COVERAGE';
export const CREATE_MEDIA_COVERAGE = 'CREATE_MEDIA_COVERAGE';
export const UPDATE_MEDIA_COVERAGE = 'UPDATE_MEDIA_COVERAGE';
export const DELETE_MEDIA_COVERAGE = 'DELETE_MEDIA_COVERAGE';
export const CHANGE_MEDIA_COVERAGE_STATUS = 'CHANGE_MEDIA_COVERAGE_STATUS';

//! Testimonial Videos
export const GET_TESTIMONIAL_VIDEOS = 'GET_TESTIMONIAL_VIDEOS';
export const SET_TESTIMONIAL_VIDEOS = 'SET_TESTIMONIAL_VIDEOS';

//! Bug Tracker
export const GET_BUG_REPORTS = 'GET_BUG_REPORTS';
export const SET_BUG_REPORTS = 'SET_BUG_REPORTS';
export const GET_BUG_REPORT_BY_ID = 'GET_BUG_REPORT_BY_ID';
export const SET_BUG_REPORT_BY_ID = 'SET_BUG_REPORT_BY_ID';
export const CREATE_BUG_REPORT = 'CREATE_BUG_REPORT';
export const UPDATE_BUG_REPORT = 'UPDATE_BUG_REPORT';
export const UPDATE_BUG_STATUS = 'UPDATE_BUG_STATUS';
export const ADD_BUG_COMMENT = 'ADD_BUG_COMMENT';
export const ADD_BUG_RESOLUTION = 'ADD_BUG_RESOLUTION';
export const ADD_BUG_TEST_REPORT = 'ADD_BUG_TEST_REPORT';
export const DELETE_BUG_REPORT = 'DELETE_BUG_REPORT';
export const GET_BUG_STATS = 'GET_BUG_STATS';
export const SET_BUG_STATS = 'SET_BUG_STATS';
export const SEARCH_BUG_REPORTS = 'SEARCH_BUG_REPORTS';
export const SET_SEARCH_BUG_REPORTS = 'SET_SEARCH_BUG_REPORTS';

//! Revenue
export const GET_REVENUE_SETTINGS = 'GET_REVENUE_SETTINGS';
export const SET_REVENUE_SETTINGS = 'SET_REVENUE_SETTINGS';
export const UPDATE_REVENUE_SETTINGS = 'UPDATE_REVENUE_SETTINGS';
export const GET_REVENUE_RECORDS = 'GET_REVENUE_RECORDS';
export const SET_REVENUE_RECORDS = 'SET_REVENUE_RECORDS';

//! Payouts
export const GET_PAYOUT_SETTINGS = 'GET_PAYOUT_SETTINGS';
export const SET_PAYOUT_SETTINGS = 'SET_PAYOUT_SETTINGS';
export const TOGGLE_AUTO_PAYOUT = 'TOGGLE_AUTO_PAYOUT';
export const GET_PENDING_PAYOUTS = 'GET_PENDING_PAYOUTS';
export const SET_PENDING_PAYOUTS = 'SET_PENDING_PAYOUTS';
export const PROCESS_PAYOUT = 'PROCESS_PAYOUT';
export const PROCESS_ALL_PAYOUTS = 'PROCESS_ALL_PAYOUTS';
export const GET_PAYOUT_HISTORY = 'GET_PAYOUT_HISTORY';
export const SET_PAYOUT_HISTORY = 'SET_PAYOUT_HISTORY';
//! Affiliate by Partner (hierarchy drill-down)
export const GET_AFFILIATE_BY_PARTNERID = "GET_AFFILIATE_BY_PARTNERID";
export const SET_AFFILIATE_BY_PARTNERID = "SET_AFFILIATE_BY_PARTNERID";
export const GET_CUSTOMER_BY_AFFILIATEID = "GET_CUSTOMER_BY_AFFILIATEID";
export const SET_CUSTOMER_BY_AFFILIATEID = "SET_CUSTOMER_BY_AFFILIATEID";
